<script setup>
import { useHR } from '@/composables/useHR'

// Module 15 (§9.2) — histori penilaian kinerja SATU pegawai lintas
// template, via GET /api/v1/employees/{employee}/performance-history
// (EmployeeCredentialController::performanceHistory()). Penilaian baru
// tetap dilakukan lewat halaman Assessment yang sudah ada (pages/
// assessment/score/[templateId].vue, subject_type=employee) — blueprint
// §Module15 hanya menyebut satu halaman baca di sini, bukan form skor
// duplikat.
definePage({
  meta: {
    layout: 'default',
    action: 'performance-manage',
    subject: 'Hr',
  },
})

const { performanceHistory, loading, fetchPerformanceHistory } = useHR()

const employeeId = ref(null)

async function onEmployeeSelected() {
  if (employeeId.value) await fetchPerformanceHistory(employeeId.value)
  else performanceHistory.value = []
}

const headers = [
  { title: 'Template', key: 'template' },
  { title: 'Skor', key: 'total_score', align: 'center', width: 100 },
  { title: 'Penilai', key: 'assessor' },
  { title: 'Tanggal', key: 'assessed_at', width: 180 },
]
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Penilaian Kinerja Pegawai
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Histori penilaian lintas template, memakai Assessment Engine (§9.2/§10.4)
    </p>

    <VCard class="mb-4">
      <VCardText>
        <MasterDataPicker
          v-model="employeeId"
          entity="employees"
          label="Pilih Pegawai"
          @update:model-value="onEmployeeSelected"
        />
      </VCardText>
    </VCard>

    <VCard>
      <VDataTable
        :headers="headers"
        :items="performanceHistory"
        :loading="loading"
        hide-default-footer
      >
        <template #item.template="{ item }">
          {{ item.template?.name ?? '-' }}
        </template>
        <template #item.total_score="{ item }">
          <VChip
            size="small"
            color="primary"
            variant="tonal"
          >
            {{ item.total_score }}
          </VChip>
        </template>
        <template #item.assessor="{ item }">
          {{ item.assessor?.name ?? '-' }}
        </template>
        <template #no-data>
          <div class="text-center py-10">
            <p class="text-medium-emphasis">
              {{ employeeId ? 'Belum ada histori penilaian.' : 'Pilih pegawai untuk melihat histori penilaian.' }}
            </p>
          </div>
        </template>
      </VDataTable>
    </VCard>
  </div>
</template>
